export const appTypes = {
  SET_SIGNUP_WIZARD_ACTIVE_PAGE_NAME: 'SET_SIGNUP_WIZARD_ACTIVE_PAGE_NAME',
  SET_AS_UNREGISTERED_USER: 'SET_AS_UNREGISTERED_USER',
  SET_USER_OTP_TOKEN: 'SET_USER_OTP_TOKEN',
  SET_WIDGET_CODE: 'SET_WIDGET_CODE',
  SET_WIDGET_TOKEN: 'SET_WIDGET_TOKEN',
  DECREMENT_VERIFICATION_CODE_TIMER: 'DECREMENT_VERIFICATION_CODE_TIMER',
  SET_VERIFICATION_CODE_TIMER_STATUS: 'SET_VERIFICATION_CODE_TIMER_STATUS',
  SET_IS_MOBILE_VALIDATED: 'SET_IS_MOBILE_VALIDATED',
  SET_MOBILE_NUMBER: 'SET_MOBILE_NUMBER',
  SET_IS_WIDGET_READY: 'SET_IS_WIDGET_READY',
  SET_LOCALE: 'SET_LOCALE',
  COUNTER_COUNT_DOWN_START: 'COUNTER_COUNT_DOWN_START',
};
